import React, { useMemo, useState } from "react";
import TextStyles from "../../../../../../components/Elements/TextStyles/TextStyles";
import CustomSwitch from "../../../../../../components/Elements/CustomSwitch/CustomSwitch";
import CardsBorder from "../../../../../../components/Cards/CardsBorder";

const formatPercent = (current, used) => {
  if (!current) return "0%";
  const value = Math.round((used / current) * 100);
  return `${Number.isFinite(value) ? value : 0}%`;
};

const CustomerLevel = ({ customerData, customerSummary, customerName }) => {
  const [formSettings, setFormSettings] = useState([
    {
      title: "Access To OffsetGo Question Bank",
      description:
        "When Enabled, Customer Can Use Any Form From The OffsetGo Library.",
      date: "2026-08-01",
      enabled: true,
    },
    {
      title: "Creation Of A Dynamic Form",
      description:
        "When Enabled, Customer Can Create Custom Forms Using Pre-Approved Questions.",
      date: "2026-08-01",
      enabled: false,
    },
  ]);

  const customerLevelLicenseHeader = [
    { key: "licenseType", label: "LICENSE TYPE" },
    { key: "current", label: "CURRENT" },
    { key: "used", label: "USED" },
    { key: "available", label: "AVAILABLE" },
    { key: "usage", label: "USAGE" },
    // { key: "date", label: "DATE" },
    // { key: "newAmount", label: "NEW AMOUNT" },
  ];

  const subAdminLicense = customerData?.license?.sub_admin || {};
  const managementLicense = customerData?.license?.management_view || {};
  const rows = useMemo(
    () => [
      {
        licenseType: "Sub Admin License",
        current: subAdminLicense.total ?? 0,
        used: subAdminLicense.used ?? 0,
        available: subAdminLicense.unused ?? 0,
        usage: formatPercent(
          subAdminLicense.total ?? 0,
          subAdminLicense.used ?? 0,
        ),
        date: "2026-08-01",
        newAmount: 0,
      },
      {
        licenseType: "Management License",
        current: managementLicense.total ?? 0,
        used: managementLicense.used ?? 0,
        available: managementLicense.unused ?? 0,
        usage: formatPercent(
          managementLicense.total ?? 0,
          managementLicense.used ?? 0,
        ),
        date: "2026-08-01",
        newAmount: 0,
      },
    ],
    [
      subAdminLicense.total,
      subAdminLicense.used,
      subAdminLicense.unused,
      managementLicense.total,
      managementLicense.used,
      managementLicense.unused,
    ],
  );

  const handleInputChange = () => {};

  return (
    <div className="mx-4">
      <CardsBorder>
        <div className="mx-4">
          <TextStyles
            className="text-[#06513D]"
            style={{ fontSize: "20px", fontWeight: 500 }}
          >
            CUSTOMER-LEVEL LICENSES
          </TextStyles>

          <p className="font-light mt-[-10px]">
            These licenses apply globally across all projects for this customer.
            Enter the number of licenses below.
          </p>
          <p className="text-sm text-gray-500 mt-1">
            {customerName || customerSummary?.name || "Customer"}
          </p>
        </div>

        <div className="py-2 mt-2 rounded-md">
          <table className="w-full text-left">
            <thead className="bg-[#E6EEEC] text-sm font-semibold text-[#1F2A37]">
              <tr>
                {customerLevelLicenseHeader.map((header) => (
                  <th key={header.key} className="px-2 py-2">
                    {header.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="text-sm text-black px-4">
              {rows.map((row, index) => (
                <tr key={index} className="border-b border-gray-300">
                  <td className="px-2 py-3">{row.licenseType}</td>
                  <td className="px-2">{row.current}</td>
                  <td className="px-2">{row.used}</td>
                  <td className="px-2">{row.available}</td>
                  <td className="px-2">
                    <div className="w-full bg-gray-200 rounded h-2">
                      <div
                        className="bg-[#06513D] h-2 rounded"
                        style={{ width: row.usage }}
                      />
                    </div>
                    <span className="text-xs">{row.usage}</span>
                  </td>
                  {/* <td className="px-2">
                    <input
                      type="date"
                      value={row.date}
                      onChange={(e) => handleInputChange(index, "date", e.target.value)}
                      className="border border-black rounded px-2 py-1 w-[130px]"
                    />
                  </td> */}
                  {/* <td className="px-2">
                    <input
                      type="number"
                      min="1"
                      value={row.newAmount === 0 ? "" : row.newAmount}
                      readOnly
                      placeholder="0"
                      className="border border-black rounded px-2 py-1 w-[60px]"
                    />
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardsBorder>

      {/* <TextStyles style={{ fontSize: "20px", fontWeight: 500 }}>
        <p className="mx-4 mt-10 text-[#06513D]">
          LICENSES & FEATURES MANAGEMENT
        </p>
      </TextStyles>

      <div className="">
        <CardsBorder>
          {formSettings.map((setting, index) => (
            <div key={index}>
              <div className="flex justify-between mx-10">
                <div>
                  <p className="text-lg font-[300]">{setting.title}</p>
                  <p className="mt-[-10px] text-[13px] text-[#808080] font-[400] ">
                    {setting.description}
                  </p>
                </div>
                <div className="flex justify-around gap-20 items-center">
                  <input
                    type="date"
                    value={setting.date}
                    onChange={(e) => {
                      const updated = [...formSettings];
                      updated[index].date = e.target.value;
                      setFormSettings(updated);
                    }}
                    className="border border-black rounded px-2 py-1 w-[120px] text-right"
                  />
                  <CustomSwitch
                    checked={setting.enabled}
                    onChange={(val) => {
                      const updated = [...formSettings];
                      updated[index].enabled = val;
                      setFormSettings(updated);
                    }}
                  />
                </div>
              </div>

              <div className="pb-3 px-4">
                <hr />
              </div>
            </div>
          ))}
        </CardsBorder>
      </div> */}
    </div>
  );
};

export default CustomerLevel;
